module.exports = __webpack_public_path__ + "static/media/W9.fff05956.png";